import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNuclearPowerPlant: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconNuclearPowerPlant"><Path d="M8.5 20.5H2.5C4.59768 14.5 5.15756 9.81421 5.64652 3.5H17.1349C17.3372 6.11206 17.5516 8.44545 17.882 10.7085" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 16.75C8.5 12.9363 11.1863 10.5 15 10.5C19.0637 10.5 21.5 12.9363 21.5 16.75V20.5H8.5V16.75Z" stroke="currentColor" strokeLinecap="square"/><Path d="M9 16.5H21" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconNuclearPowerPlant;
